var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.statusText)?_c('span',[_c('Badge',{staticClass:"'big no-text mr-3",class:_vm.statusClass,attrs:{"status":_vm.statusColor}}),_vm._v(" "+_vm._s(_vm.statusText))],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }